import { useCallback, useEffect, useRef, useState } from "react";
import { NetworkConfig } from "src/network/NetworkConfig";

const MAX_ATTEMPTS = 5;
const RETRY_DELAY_MS = 3000;

export const useThumbnailRetry = (url?: string) => {
    const [attempt, setAttempt] = useState<number>(0);
    const timerRef = useRef<ReturnType<typeof setTimeout>>();

    const isThumbnailUrl = !!url && url.startsWith(NetworkConfig.openThumbnailUrl);

    useEffect(() => {
        setAttempt(0);

        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [url]);

    const src = isThumbnailUrl && attempt > 0 ? `${url}?retry=${attempt}` : url;

    const retryOnError = useCallback((): boolean => {
        if (!isThumbnailUrl || attempt >= MAX_ATTEMPTS) {
            return false;
        }

        timerRef.current = setTimeout(
            () => {
                setAttempt((currentAttempt) => currentAttempt + 1);
            },
            RETRY_DELAY_MS * (attempt + 1)
        );

        return true;
    }, [isThumbnailUrl, attempt]);

    return { src, retryOnError };
};
